module.exports = __webpack_public_path__ + "static/img/serve7.8acc6243.png";